import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';
import { ReportingComponent } from './reporting.component';

import { ReportHeaderComponent } from './header/report-header.component';
import { MyReportsComponent } from './my-reports/my-reports.component';

import { ReportFooterComponent } from './footer/report-footer.component';
import { ReportParametersComponent } from './parameters/report-parameters.component';
import { AllReportsComponent } from './all-reports/all-reports.component';
import { ReportsFilter } from './all-reports/all-reports.reportsFilter';
import { ReportSettingsFoldersComponent } from './report-settings/report-settings.folders.component';
import { ReportSnapshotsComponent } from './report-snapshots/report-snapshots.component';
import { ReportFoldersComponent } from './report-folders/report-folders.component';
import { ReportOptionsComponent } from './definitions/report-options.component';
import { AddReportFolderComponent } from './report-folders/add-folder/add-folder.component';
import { DeleteReportFolderComponent } from './report-folders/delete-folder/delete-folder.component';
import { ConfirmDeleteSnapshotComponent } from './report-snapshots/confirm-delete-snapshot.component';
import { ReportInFolderFilter } from './filters/report-in-folder-filter';
import { SnapshotInFolderFilter } from './filters/snapshot-in-folder-filter';

import { MatDialogModule } from '@angular/material/dialog';
import { ReportSettingsAutoRunComponent } from './report-settings/report-settings-autorun.component';
import { ReportLegendComponent } from './report-legend/report-legend.component';
import { ReportAutoRunMessageComponent } from './report-settings/report-autorun-message.component';
import { ConfirmReportToEmailComponent } from './parameters/confirm-report-to-email.component';
import { ReportOptionsHowToComponent } from './definitions/report-options-how-to.component';

import { ArchiveReportModalComponent } from './archive-report/archive-report-modal.component';
import { PortfolioService } from '../../student360/portfolio/portfolio.service';
import { ConfirmArchiveReportComponent } from './archive-report/confirm-archive-report.component';
import { ReportQueueComponent } from './report-queue/report-queue.component';
import { DatePipe } from '@angular/common';
import { ManualEntryRostersComponent } from './V9/manual-entry-rosters/manual-entry-rosters.component';
import { GradebookStatisticalAnalysisReportComponent } from './V9/gradebook-statistical-analysis-report/gradebook-statistical-analysis-report.component';
import { ClassListAllComponent } from './V9/class-list-all/class-list-all.component';
import { ClassListAllAttendanceNotMarkedComponent } from './V9/class-list-all-attendance-not-marked/class-list-all-attendance-not-marked.component';
import { TeacherSummaryPreviewComponent } from './V9/teacher-summary-preview/teacher-summary-preview.component';
import { GradebookProgessReportComponent } from './V9/gradebook-progress-report/gradebook-progress-report.component';
import { AttendanceHistoryByClassComponent } from './V9/attendance-history-by-class/attendance-history-by-class.component';
import { GradebookAssignmentsByStandardComponent } from './V9/gradebook-assignments-by-standard/gradebook-assignments-by-standard.component';
import { ReportTemplateClassListComponent } from './V9/report-template-class-list/report-template-class-list.component';
import { StudentGradebookIDsComponent } from './V9/student-gradebook-ids/student-gradebook-ids.component';
import { GenericReportComponent } from './V9/generic-report/generic-report.component';
import { GradebookByClassGridComponent } from './V9/gradebook-by-class-grid/gradebook-by-class-grid.component';
import { GenericListSelectorComponent } from '../../shared-components/generic-list-selector/generic-list-selector.component';
import { ArchiveProcessComponent } from './archive-report/archive-process.component';
import { ConfirmCancelArchiveReportComponent } from './archive-report/confirm-cancel-archive.component';
import { LetterPrintOptionComponent } from './V9/letter-print-option/letter-print-option.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { V9ReportParametersComponent } from './V9/parameters/v9-report-parameters.component';

import { AutomatedTestingSetupComponent } from './automated-testing-setup/automated-testing-setup.component';
import { AutomatedTestingModalComponent } from './automated-testing-setup/automated-testing-modal.component';
import { ConfirmModalComponent } from './automated-testing-setup/confirm.component';
import { QuickViewModalComponent } from './automated-testing-setup/quickview.component';

import { V9LetterReportParametersComponent } from './V9/parameters/v9-letter-report-parameters/v9-letter-report-parameters.component';
import { V9ReportParameterTabsFilterPipe } from './V9/parameters/v9-report-parameter-tabs-filter.pipe';
import { ElementListModalComponent } from './automated-testing-setup/element-list.component';
import { ElementAddEditModalComponent } from './automated-testing-setup/element-add-edit-modal.component';
import { AreaListModalComponent } from './automated-testing-setup/area-list.component';
import { AreaAddEditModalComponent } from './automated-testing-setup/area-add-edit-modal.component';
import { MedicalDataListingGridComponent } from './V9/medical-data-listing-grid/medical-data-listing-grid.component';



@NgModule({
    declarations: [
        ReportingComponent,
        ReportHeaderComponent,
        MyReportsComponent,
        ReportParametersComponent,
        AllReportsComponent,
        ReportFooterComponent,
        ReportOptionsComponent,
        ReportsFilter,
        ReportSettingsFoldersComponent,
        ReportSnapshotsComponent,
        ConfirmDeleteSnapshotComponent,
        ReportInFolderFilter,
        SnapshotInFolderFilter,
        ReportFoldersComponent,
        AddReportFolderComponent,
        DeleteReportFolderComponent,
        ReportSettingsAutoRunComponent,
        ReportLegendComponent,
        ReportAutoRunMessageComponent,
        ConfirmReportToEmailComponent,
        ReportOptionsHowToComponent,
        ArchiveReportModalComponent,
        ConfirmArchiveReportComponent,
        ManualEntryRostersComponent,
        ClassListAllComponent,
        ClassListAllAttendanceNotMarkedComponent,
        ReportQueueComponent,
        GradebookStatisticalAnalysisReportComponent,
        TeacherSummaryPreviewComponent,
        GradebookProgessReportComponent,
        GradebookAssignmentsByStandardComponent,
        ReportTemplateClassListComponent,
        AttendanceHistoryByClassComponent,
        StudentGradebookIDsComponent,
        GenericReportComponent,
        GradebookByClassGridComponent,
        GenericListSelectorComponent,
        ArchiveProcessComponent,
        ConfirmCancelArchiveReportComponent,
        LetterPrintOptionComponent,
        MedicalDataListingGridComponent,
        V9ReportParametersComponent,
        AutomatedTestingSetupComponent,
        AutomatedTestingModalComponent,
        ConfirmModalComponent,
        V9LetterReportParametersComponent,
        V9ReportParameterTabsFilterPipe,
        ElementListModalComponent,
        ElementAddEditModalComponent,
        AreaListModalComponent,
        AreaAddEditModalComponent,
        QuickViewModalComponent,
    ],
    imports: [
        SharedComponentsModule,
        MatDialogModule,
        FormsModule,
        ScrollingModule,
    ],
    providers: [PortfolioService, DatePipe, V9ReportParameterTabsFilterPipe]
}) // end @NgModule

export class ReportingModule {
} // end export class ReportingModule
